<div class="page-container">
  <div class="page-header">
    <div>
      <h1 class="gradient-text">Паркінги</h1>
      <p class="subtitle">Управління торговельними центрами та паркувальними зонами</p>
    </div>
    <button mat-raised-button color="primary" class="add-button">
      <mat-icon>add</mat-icon>
      Додати паркінг
    </button>
  </div>

  <mat-card>
    <mat-card-content>
      @if (loading) {
        <div class="loading-container">
          <mat-spinner></mat-spinner>
        </div>
      } @else {
        <table mat-table [dataSource]="parkingMalls" class="malls-table">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Назва</th>
            <td mat-cell *matCellDef="let mall">
              <div class="mall-info">
                @if (mall.logo) {
                  <img [src]="mall.logo" alt="{{mall.name}}" class="mall-logo">
                }
                <strong>{{mall.name}}</strong>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef>Адреса</th>
            <td mat-cell *matCellDef="let mall">
              <div class="location-info">
                <mat-icon>location_on</mat-icon>
                {{mall.location.address}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="spaces">
            <th mat-header-cell *matHeaderCellDef>Місця</th>
            <td mat-cell *matCellDef="let mall">
              <div class="spaces-info">
                <span class="available">{{mall.availableSpaces}}</span> / {{mall.totalSpaces}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="occupancy">
            <th mat-header-cell *matHeaderCellDef>Заповненість</th>
            <td mat-cell *matCellDef="let mall">
              <mat-chip [class.high]="getOccupancy(mall) > 80" 
                        [class.medium]="getOccupancy(mall) > 50 && getOccupancy(mall) <= 80"
                        [class.low]="getOccupancy(mall) <= 50">
                {{getOccupancy(mall)}}%
              </mat-chip>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Статус</th>
            <td mat-cell *matCellDef="let mall">
              <mat-chip [class.active]="mall.isActive" [class.inactive]="!mall.isActive">
                {{mall.isActive ? 'Активний' : 'Неактивний'}}
              </mat-chip>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Дії</th>
            <td mat-cell *matCellDef="let mall">
              <button mat-icon-button (click)="editMall(mall)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteMall(mall)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      }
    </mat-card-content>
  </mat-card>
</div>
